import LySpit from './lySpit';

export default LySpit;
